import React, {Component} from 'react';

class DottedLoader extends Component {
  render() {
    return (
      <div className={'dotted-loader'}>
        {this.props.children || "Loading"}<span>.</span><span>.</span><span>.</span>
      </div>
    );
  }
}

export default DottedLoader;